import React from 'react';
import classnames from 'classnames';
import { Button, Flex, Label, Pane, TextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Validator } from '@leverege/validator';
import S from '../Login.css';
import FieldErrorsComponent from "./FieldErrorsComponent.js";
import useForm from "../hooks/useForm.js";
const {
  t,
  tf
} = I18N.ns('login.ActivateAccount');
export default function NewUserForm(props) {
  const {
    alreadyRegisteredVariant,
    className,
    displayLogo,
    email,
    error,
    ErrorComponent,
    isLoading,
    isLoggedIn,
    labelClassName,
    labelVariant,
    loading,
    LoadingComponent,
    loginLogoVariant,
    LogoComponent,
    onBackToLogin,
    onSubmit: pOnSubmit,
    PasswordErrorsComponent,
    passwordValidator,
    passwordVariant,
    phone,
    submitClassName,
    username,
    variant,
    warningClassName,
    warningLocation,
    warningVariant
  } = props;
  const {
    values,
    errors,
    onChange,
    onSubmit
  } = useForm({
    fields: {
      username: {
        initialValue: username
      },
      email: {
        initialValue: email,
        validator: Validator.isEmail,
        errorMessage: tf('emailError')
      },
      name: {
        validator: Validator.required,
        errorMessage: tf('nameError')
      },
      phone: {
        validator: Validator.optional(Validator.isPhone),
        optional: true,
        initialValue: phone
      },
      password: {
        validator: (value, values) => {
          if (!passwordValidator) {
            return true;
          }
          const validationResult = passwordValidator.validate(value);
          return validationResult.valid ? true : Object.values(validationResult.errors);
        }
      }
    },
    onSubmit: pOnSubmit
  });
  return /*#__PURE__*/React.createElement(Pane, {
    variant: variant,
    className: classnames(className, S.pane),
    layout: "flex:colS"
  }, (loading || isLoggedIn || isLoading) && /*#__PURE__*/React.createElement("div", {
    className: S.blocker
  }, /*#__PURE__*/React.createElement(LoadingComponent, {
    color: "var(--color-brand500)",
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%'
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    inline: true,
    variant: "colM",
    align: "center"
  }, displayLogo && LogoComponent ? /*#__PURE__*/React.createElement(LogoComponent, {
    variant: loginLogoVariant
  }) : null, warningLocation === 'top' && ErrorComponent ? /*#__PURE__*/React.createElement(ErrorComponent, {
    variant: warningVariant,
    className: warningClassName,
    error: error
  }) : null, /*#__PURE__*/React.createElement("form", {
    className: S.form,
    onSubmit: e => {
      e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colM",
    align: "stretch"
  }, /*#__PURE__*/React.createElement(Label, {
    variant: labelVariant,
    className: labelClassName
  }, t('usernameText')), /*#__PURE__*/React.createElement(TextInput, {
    disabled: true,
    value: values.username
  }), /*#__PURE__*/React.createElement(FieldErrorsComponent, {
    errors: errors.username
  }), /*#__PURE__*/React.createElement(Label, {
    variant: labelVariant,
    className: labelClassName
  }, t('emailText')), /*#__PURE__*/React.createElement(TextInput, {
    error: !!errors.email,
    value: values.email,
    onChange: onChange,
    eventData: "email",
    hint: t('emailHint')
  }), /*#__PURE__*/React.createElement(FieldErrorsComponent, {
    errors: errors.email
  }), /*#__PURE__*/React.createElement(Label, {
    variant: labelVariant,
    className: labelClassName
  }, t('nameText')), /*#__PURE__*/React.createElement(TextInput, {
    error: !!errors.name,
    value: values.name,
    onChange: onChange,
    eventData: "name",
    hint: t('nameHint')
  }), /*#__PURE__*/React.createElement(FieldErrorsComponent, {
    errors: errors.name
  }), /*#__PURE__*/React.createElement(Label, {
    variant: labelVariant,
    className: labelClassName
  }, t('phoneText')), /*#__PURE__*/React.createElement(TextInput, {
    autoComplete: "tel-national",
    error: !!errors.phone,
    value: values.phone,
    onChange: onChange,
    eventData: "phone",
    hint: t('phoneHint')
  }), /*#__PURE__*/React.createElement(FieldErrorsComponent, {
    errors: errors.phone
  }), /*#__PURE__*/React.createElement(Label, {
    variant: labelVariant,
    className: labelClassName
  }, t('passwordText')), /*#__PURE__*/React.createElement(TextInput, {
    error: !!errors.password,
    variant: passwordVariant,
    password: true,
    value: values.password,
    onChange: onChange,
    eventData: "password",
    changeOnReturn: false,
    hint: t('passwordHint')
  }), /*#__PURE__*/React.createElement(PasswordErrorsComponent, {
    errors: errors.password,
    value: values.password,
    validator: passwordValidator
  }), /*#__PURE__*/React.createElement(Label, {
    variant: labelVariant,
    className: labelClassName
  }, t('confirmText')), /*#__PURE__*/React.createElement(TextInput, {
    error: !!errors.confirm,
    variant: passwordVariant,
    password: true,
    value: values.confirm,
    onChange: onChange,
    eventData: "confirm",
    hint: t('confirmHint')
  }), /*#__PURE__*/React.createElement(FieldErrorsComponent, {
    errors: errors.confirm
  }), /*#__PURE__*/React.createElement(Button, {
    className: submitClassName,
    type: "submit",
    onClick: onSubmit
  }, t('submit')), /*#__PURE__*/React.createElement(Button, {
    variant: alreadyRegisteredVariant,
    onClick: onBackToLogin
  }, t('alreadyRegistered'))))));
}